import type { FormError, FormErrorEvent, FormErrorWithId, FormValidationError } from 'ui/util/ui/import';

const getElement = (error: FormErrorWithId | FormError): HTMLElement | null => {
  if ('id' in error && error.id) {
    return document.getElementById(error.id);
  }
  if (error.name) {
    const elements = document.getElementsByName(error.name);
    return elements[0] ?? null;
  }
  return null;
};

type FormErrorScrollSource = FormErrorEvent | FormValidationError | { errors: Array<FormErrorWithId | FormError> };

export const onFormErrorFocus = (event: FormErrorScrollSource, scroll = false) => {
  const firstError = event.errors[0];
  if (firstError) {
    const element = getElement(firstError);
    if (element) {
      if (scroll) {
        element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      window.setTimeout(() => { element.focus(); }, 0);
    }
  }
};

export const onFormErrorScrollFocus = (event: FormErrorScrollSource) => onFormErrorFocus(event, true);
